
export const sectionTitle = {
    color: "black",
    fontSize: {
        xs: '36px',
        sm: '40px',
        md: '44px',
        lg: '48px',
    },
    fontFamily: 'ButlerLight',
};

export const description = {
    fontFamily: "Jost-Regular",
    fontSize: '22px',
    color: 'black',
}
